import api from "./api";
const svc = {
  buscarConfig: ()     => api("GET",  "/email/config"),
  salvarConfig: data   => api("PUT",  "/email/config", data),
  testar:       data   => api("POST", "/email/testar", data),
  listarLog:    (p={}) => {
    const qs = new URLSearchParams(Object.entries(p).filter(([, v]) => v !== "" && v !== undefined));
    return api("GET", `/email/log?${qs}`);
  },
  reenviar:     id     => api("POST", `/email/reenviar/${id}`),
  stats:        ()     => api("GET",  "/email/stats"),
};
export default svc;
